import styled from "styled-components";
import { H2, P } from "@/lib/styles";
import { pageMargins } from "@/lib/styles/helpers";

export const ContactCarouselContainer = styled.div`
  margin-bottom: 100px;

  ${({ theme }) => theme.mediaQueries.tablet} {
    margin-bottom: 150px;
  }
`;

export const TextContainer = styled.div`
  ${pageMargins};

  ${({ theme }) => theme.mediaQueries.laptop} {
    max-width: 100rem;
  }
`;

export const Heading = styled(H2)`
  margin-top: 10rem;
  ${({ theme }) => theme.mediaQueries.laptop} {
    width: 50%;
  }
`;

export const Paragraph = styled(P)`
  margin-top: 1rem;
  margin-bottom: 2.5rem;
  padding: 0.5rem 0;
  background-color: ${({ theme }) => theme.colors.white};

  ${({ theme }) => theme.mediaQueries.laptop} {
    width: 50%;
  }

  a {
    color: ${({ theme }) => theme.colors.red};
  }
`;
